import React from 'react'
import { Col,Row, Container } from 'react-bootstrap'

export default function Footer() {
    return (
        <div className="container-fluid footer-container " >
            <Container  className="footer-container-one" >
                <Row xl={12} >
                    <Col xl={3} lg={3} md={4} sm={5} xs={5} >
                        <img className="footer-image" src="images/logo/logo.png" />
                    </Col>
                    <Col xl={3} lg={3} md={4} sm={7} xs={7} >
                        <ul className="footer-link" >
                            <h3 className="footer-quick-link" >Quick Links</h3>
                            <li className="footer-link-a"> <a href="">About Kalpataru</a> </li>
                            <li className="footer-link-a"><a href=""> Treatments</a> </li>
                            <li className="footer-link-a"><a href=""> Gallery</a> </li>
                            <li className="footer-link-a"><a href=""> Carrers</a> </li>
                            <li className="footer-link-a"><a href=""> Facilities</a> </li>
                        </ul>
                    </Col>
                    <Col className="footer-col-3" xl={3} lg={3} md={4} sm={7} xs={7} >
                        <ul className="footer-link">
                            <h3 className="footer-quick-link">Contact Us</h3>
                            <li> Kalpataru Ayurveda, </li>
                            <li>15 -143 ,New Mirjalaguda, </li>
                            <li> Malkajgiri,Hyderabad,500047 </li>
                            <li>Phone: +919848032919 </li>
                            <li>Email: info@kalpataru.com </li>
                        </ul>
                    </Col>
                    <Col className="footer-col-4" xl={3} lg={3} md={4} sm={5} xs={5} >
                        <h3 className="footer-quick-link">Follow Us</h3>
                        <div className="footer-icon-div" >
                            <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer"> <img className="footer-icon" src="images/icons/facebook.png" /> </a>
                            <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer"> <img className="footer-icon" src="images/icons/instagram.png" /> </a>
                            <a href="https://www.youtube.com/" target="_blank" rel="noopener noreferrer"> <img className="footer-icon" src="images/icons/youtube.png" /> </a>
                        </div>
                    </Col>
                </Row>
                <Row className="mt-4">
                    <Col className="text-center" >
                    <span> © All Rights Reserved 2021 </span>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
